import { BiSolidCheckCircle } from "react-icons/bi";

export default function MarketStep4({selectedData}) {
  return (
    <>
      <div className='modal-content'>
        <h3>마켓등록 확인<span className='on'><BiSolidCheckCircle /></span></h3>
				<div
					className='modal-body'
				>
					<div className='modal-row'>
						<div className='modal-column'>
							<span className='key'>마켓</span>
							<span className='value'>{selectedData.market}</span>
						</div>
						<div className='modal-column'>
							<span className='key'>마켓 아이디</span>
							<span className='value'>{selectedData.marketID}</span>
						</div>
					</div>
					<div className='modal-column'>
						<span className='key'>작업줄 명</span>
						<span className='value'>{selectedData.taskName}</span>
					</div>
					<div className='modal-column'>
						<span className='key'>템플릿</span>
						<span className='value'>{selectedData.template}</span>
					</div>
					<div className='modal-column'>
						<span className='key'>북마크 상품</span>
						<span className='value'>{selectedData.scrap}</span>
					</div>
				</div>
			</div>
    </>
  )
}
